//Siliconminds login.jsx


import React, { useState, useEffect } from "react";
import { DollarSign, Briefcase, Video, Eye, EyeOff } from "lucide-react";
import { Toast } from "react-bootstrap";
import { Link } from "react-router-dom";
import axios from "axios";
import { Helmet } from "react-helmet";
import { getAuth, signInWithPopup, GoogleAuthProvider } from "firebase/auth";
import { ref, set, getDatabase } from "firebase/database";
import firebaseConfig from "../../firebase-Config"; 
import ENDPOINT from "../../data/ENDPOINT";
import SecurityHeaders from "../../data/SecurityHeaders";
import LogoutAllNotification from "./LogoutAllNotification";
import "../../assets/css/LoginPage.css"; // Keep lyfax CSS for exact design

export default function Login() {
  const [email, setemail] = useState(null);
  const [password, setpassword] = useState(null);
  const [isFetching, setisFetching] = useState(false);
  const [loginerror, setloginerror] = useState(null);
  const [ToastTitle, setToastTitle] = useState(null);
  const [ToastMessage, setToastMessage] = useState(null);
  const [showA, setShowA] = useState(false);
  const toggleShowA = () => setShowA(!showA);
  const [visibility, setvisibility] = useState(false);
  const [loading, setloading] = useState(false);

  const redirect = sessionStorage.getItem("next") || "/dashboard";
  const msg = sessionStorage.getItem("msg") || null;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const loginaction = async (e) => {
    e.preventDefault();
    setisFetching(true);
    const formdata = new FormData();
    formdata.append("email", email);
    formdata.append("password", password);
    formdata.append("sc_id", JSON.parse(localStorage.getItem("uid")) || "");

    try {
      const res = await axios.post(
        `${ENDPOINT}login.php`,
        formdata,
        SecurityHeaders,
      );

      setisFetching(false);
      if (res.data.status === "success" && res.data.data) {
        localStorage.setItem("user", JSON.stringify(res.data.data));
        setToastTitle("Login Successful");
        setToastMessage("Redirecting...");
        setShowA(true);

        if (
          sessionStorage.getItem("next") === "null" ||
          sessionStorage.getItem("next") === "" ||
          sessionStorage.getItem("next") === null ||
          sessionStorage.getItem("next") === undefined
        ) {
          sessionStorage.setItem("next", "");
          window.location.replace("/dashboard");
        } else {
          const redirection_url = redirect;
          sessionStorage.setItem("next", "");
          window.location.replace(redirection_url);
        }
      } else if (
        res.data.status === "error" &&
        res.data.data === "limit exceeded"
      ) {
        setloginerror("limit exceeded");
      } else if (
        res.data.status === "error" &&
        res.data.data === "wrong credentials"
      ) {
        setloginerror("wrong credentials");
        setToastTitle("Login Error !");
        setToastMessage("Invalid email or password.");
        setShowA(true);
      } else if (
        res.data.status === "error" &&
        res.data.data === "session error"
      ) {
        setToastTitle("Something went wrong !");
        setToastMessage("Please try again after sometime.");
        setShowA(true);
      } else {
        setToastTitle("Something went wrong!");
        setToastMessage("Please try again after sometime.");
        setShowA(true);
      }
    } catch (err) {
      setisFetching(false);
      setToastTitle("Something went wrong !");
      setToastMessage("Please try again after sometime.");
      setShowA(true);
    }
  };

  const InitiateGoogleLogin = () => {
    const provider = new GoogleAuthProvider();
    const auth = getAuth();
    signInWithPopup(auth, provider)
      .then((result) => {
        const credential = GoogleAuthProvider.credentialFromResult(result);
        const token = credential.accessToken;
        const user = result.user;

        const dbRef = ref(getDatabase(), "/auth/" + user.uid);
        set(dbRef, {
          sessionID: credential.accessToken,
          email: user.providerData[0].email,
        })
          .then(() => {
            CheckGoogleSignin({
              payload: { uid: user.uid, token: credential.accessToken },
            });
          })
          .catch((error) => {
            console.error("Error setting data in the database:", error);
            setToastTitle("Error");
            setToastMessage("Google sign-in failed");
            setShowA(true);
          });
      })
      .catch((error) => {
        setToastTitle("Error");
        setToastMessage("Google sign-in failed");
        setShowA(true);
      });
  };

  const CheckGoogleSignin = async ({ payload }) => {
    setloading(true);
    const data = new FormData();
    data.append("uid", payload.uid);
    data.append("token", payload.token);

    try {
      const res = await axios.post(
        ENDPOINT + "/google-signin.php",
        data,
        SecurityHeaders,
      );
      setloading(false);
      if (res.data.status === "success" && res.data.data) {
        localStorage.setItem("user", JSON.stringify(res.data.data));
        setToastTitle("Login Successful");
        setToastMessage("Redirecting...");
        setShowA(true);

        if (
          sessionStorage.getItem("next") === "null" ||
          sessionStorage.getItem("next") === "" ||
          sessionStorage.getItem("next") === null ||
          sessionStorage.getItem("next") === undefined
        ) {
          sessionStorage.setItem("next", "");
          window.location.replace("/dashboard");
        } else {
          const redirection_url = redirect;
          sessionStorage.setItem("next", "");
          window.location.replace(redirection_url);
        }
      } else {
        setToastTitle(res.data.title || "Error");
        setToastMessage(res.data.msg || "Google sign-in failed");
        setShowA(true);
      }
    } catch (error) {
      setloading(false);
      setToastTitle("Error");
      setToastMessage("Google sign-in failed");
      setShowA(true);
    }
  };

  const toggleVisibility = () => {
    setvisibility(!visibility);
  };

  return (
    <>
      <Helmet>
        <title>Login | SiliconMinds</title>
        <meta
          name="description"
          content="Login into SiliconMinds for placement guaranteed training | online training | offline training | pre-recorded courses | online courses | offline courses"
        />
      </Helmet>

      <Toast
        onClose={toggleShowA}
        show={showA}
        delay={4000}
        autohide
        className="position-fixed top-0 end-0 m-3"
        style={{ zIndex: 9999 }}
      >
        <Toast.Header>
          <strong className="me-auto">{ToastTitle}</strong>
        </Toast.Header>
        <Toast.Body>{ToastMessage}</Toast.Body>
      </Toast>

      <div className="cybersecurity-login min-vh-100 d-flex justify-content-center align-items-center p-3">
        <div
          className="login-container w-100 d-flex"
          style={{
            maxWidth: "1200px",
            overflow: "hidden",
            borderRadius: "20px",
          }}
        >
          {/* Left Section - Hero */}
          <div
            className="hero-section d-none d-lg-flex flex-column justify-content-center align-items-center"
            style={{
              flex: 1,
              minHeight: "600px",
              position: "relative",
            }}
          >
            {/* Animated background shapes */}
            <div className="hero-bg-shapes">
              <div className="shape shape-1"></div>
              <div className="shape shape-2"></div>
              <div className="shape shape-3"></div>
            </div>
            <div
              className="hero-cards"
              style={{ position: "relative", zIndex: 2 }}
            >
              {/* Cybersecurity illustration - Lock/Security theme */}
              <svg
                viewBox="0 0 400 400"
                className="cyber-illustration"
                style={{ width: "320px", height: "320px" }}
              >
                {/* Padlock shape */}
                <g>
                  {/* Lock body */}
                  <rect
                    x="120"
                    y="180"
                    width="160"
                    height="140"
                    rx="15"
                    fill="none"
                    stroke="#f0dd11ff"
                    strokeWidth="3"
                    opacity="0.8"
                  />

                  {/* Lock keyhole */}
                  <circle
                    cx="200"
                    cy="245"
                    r="12"
                    fill="none"
                    stroke="#f0dd11ff"
                    strokeWidth="2.5"
                    opacity="0.7"
                  />
                  <path
                    d="M 200 257 L 200 270"
                    stroke="#f0dd11ff"
                    strokeWidth="2.5"
                    opacity="0.7"
                  />

                  {/* Lock shackle (top arc) */}
                  <path
                    d="M 150 180 Q 150 80 200 80 Q 250 80 250 180"
                    fill="none"
                    stroke="#f0dd11ff"
                    strokeWidth="3"
                    opacity="0.8"
                  />

                  {/* Inner glow circles */}
                  <circle
                    cx="200"
                    cy="245"
                    r="18"
                    fill="none"
                    stroke="#ec4899"
                    strokeWidth="1.5"
                    opacity="0.4"
                  />

                  {/* Data nodes around lock */}
                  <circle
                    cx="100"
                    cy="120"
                    r="8"
                    fill="#10d981"
                    opacity="0.6"
                  />
                  <line
                    x1="108"
                    y1="120"
                    x2="140"
                    y2="140"
                    stroke="#f0dd11ff"
                    strokeWidth="1.5"
                    opacity="0.3"
                  />

                  <circle
                    cx="300"
                    cy="130"
                    r="8"
                    fill="#ec4899"
                    opacity="0.5"
                  />
                  <line
                    x1="292"
                    y1="130"
                    x2="260"
                    y2="150"
                    stroke="#ec4899"
                    strokeWidth="1.5"
                    opacity="0.3"
                  />

                  <circle cx="80" cy="250" r="8" fill="#f59e0b" opacity="0.5" />
                  <line
                    x1="88"
                    y1="250"
                    x2="120"
                    y2="250"
                    stroke="#f59e0b"
                    strokeWidth="1.5"
                    opacity="0.3"
                  />

                  <circle
                    cx="320"
                    cy="260"
                    r="8"
                    fill="#10d981"
                    opacity="0.5"
                  />
                  <line
                    x1="312"
                    y1="260"
                    x2="280"
                    y2="260"
                    stroke="#f0dd11ff"
                    strokeWidth="1.5"
                    opacity="0.3"
                  />

                  {/* Scanning effect */}
                  <g opacity="0.3">
                    <line
                      x1="130"
                      y1="200"
                      x2="270"
                      y2="200"
                      stroke="#f0dd11ff"
                      strokeWidth="1"
                    />
                    <line
                      x1="130"
                      y1="220"
                      x2="270"
                      y2="220"
                      stroke="#f0dd11ff"
                      strokeWidth="1"
                    />
                    <line
                      x1="130"
                      y1="240"
                      x2="270"
                      y2="240"
                      stroke="#f0dd11ff"
                      strokeWidth="1"
                    />
                    <line
                      x1="130"
                      y1="260"
                      x2="270"
                      y2="260"
                      stroke="#f0dd11ff"
                      strokeWidth="1"
                    />
                  </g>
                </g>
              </svg>
            </div>
          </div>

          {/* Right Section - Form */}
          <div
            className="form-section"
            style={{ flex: 1, padding: "2.5rem 2rem" }}
          >
            <div className="form-wrapper">
              <div className="text-center mb-5">
                <h1 className="login-title mb-2">Welcome Back, to SiliconMinds</h1>
                <p className="login-subtitle">
                  Don't have an account?{" "}
                  <Link to="/signup" className="signup-link">
                    Sign up
                  </Link>
                </p>
              </div>

              {/* Google Sign In */}
              <button
                type="button"
                className="google-signin-btn w-100 mb-3"
                onClick={InitiateGoogleLogin}
                disabled={loading}
              >
                <svg
                  viewBox="0 0 24 24"
                  width="20"
                  height="20"
                  style={{ marginRight: "8px" }}
                >
                  <path
                    fill="#4285F4"
                    d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
                  />
                  <path
                    fill="#34A853"
                    d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
                  />
                  <path
                    fill="#FBBC05"
                    d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
                  />
                  <path
                    fill="#EA4335"
                    d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
                  />
                </svg>
                {loading ? "Signing in..." : "Sign in with Google"}
              </button>

              <div className="divider-section">
                <span>Or</span>
              </div>

              <p className="text-danger text-center">{msg ? msg : ""}</p>

              <form onSubmit={loginaction} noValidate>
                {loginerror ? (
                  loginerror === "limit exceeded" ? (
                    <LogoutAllNotification usercredentials={{ email, password }} />
                  ) : loginerror === "wrong credentials" ? (
                    <div
                      className="alert alert-danger"
                      style={{ borderRadius: "8px", marginBottom: "16px" }}
                    >
                      Invalid email or password
                    </div>
                  ) : loginerror === "session error" ? (
                    <div
                      className="alert alert-danger"
                      style={{ borderRadius: "8px", marginBottom: "16px" }}
                    >
                      Session error occurred
                    </div>
                  ) : null
                ) : null}

                {/* Email */}
                <div className="mb-3">
                  <input
                    type="email"
                    className="form-field"
                    value={email || ""}
                    onChange={(e) => setemail(e.target.value)}
                    placeholder="Email address"
                  />
                </div>

                {/* Password */}
                <div className="mb-3">
                  <div style={{ position: "relative" }}>
                    <input
                      type={visibility ? "text" : "password"}
                      className="form-field"
                      value={password || ""}
                      onChange={(e) => setpassword(e.target.value)}
                      placeholder="Password"
                      style={{ paddingRight: "40px" }}
                    />
                    <button
                      type="button"
                      onClick={toggleVisibility}
                      className="password-toggle-btn"
                    >
                      {visibility ? <EyeOff size={18} /> : <Eye size={18} />}
                    </button>
                  </div>
                </div>

                {/* Remember & Forgot */}
                <div className="d-flex justify-content-between align-items-center mb-4">
                  <div
                    className="checkbox-group"
                    style={{ margin: 0, gap: "8px", marginBottom: 0 }}
                  >
                    <input type="checkbox" id="remember" defaultChecked />
                    <label
                      htmlFor="remember"
                      style={{ margin: 0, marginBottom: 0 }}
                    >
                      Remember me
                    </label>
                  </div>
                  <Link to="/password-reset" className="forgot-link">
                    Forgot Password?
                  </Link>
                </div>

                {/* Submit Button */}
                <button
                  type="submit"
                  className="submit-btn w-100"
                  disabled={isFetching}
                >
                  {isFetching ? "Signing in..." : "Sign In"}
                </button>

                {/* Signup Link */}
                <div className="text-center mt-4">
                  <small className="text-white">
                    Don't have an account?{" "}
                    <Link to="/signup" className="signup-link">
                      Create one
                    </Link>
                  </small>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
